import dayjs from 'dayjs';
import { getInicioEFimDoDia } from '~/graphql/pre-defined-filters/utils';

interface CompromissosAtrasadosOptions {
  gerencia?: number;
  responsaveis?: string[];
}

export default function (options?: CompromissosAtrasadosOptions) {
  const now = dayjs
    .tz(
      `${dayjs().format('DD/MM/YYYY HH:mm:ss')}`,
      'DD/MM/YYYY HH:mm:ss',
      'America/Manaus',
    )
    .utc()
    .format();

  const [_, finalDoDia] = getInicioEFimDoDia();

  const baseFilter = {
    and: [
      {
        status: {
          eq: 1,
        },
      },
      {
        dataVencimento: {
          lte: finalDoDia,
        },
      },
      {
        dataVencimento: {
          gte: now,
        },
      },
    ],
  };

  const ands: any[] = [baseFilter];

  if (options?.gerencia) {
    ands.push({
      responsavel: {
        perfisAcesso: {
          some: {
            perfil: {
              eq: options.gerencia,
            },
          },
        },
      },
    });
  }

  if (options?.responsaveis && options?.responsaveis.length > 0) {
    ands.push({
      responsavelCodigo: {
        in: options.responsaveis,
      },
    });
  }

  return {
    where: {
      and: ands,
    },
  };
}
